<div class="flex items-center justify-end">
        <button  (click)="openDialog()"
                class="flex items-center font-semibold border-2 border-slate-600 bg-green-600 py-2 px-4 rounded-md transition-all shadow-lg hover:shadow-2xl text-white  hover:bg-green-700 hover:border-slate-800 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none">
            <mat-icon svgIcon="heroicons_outline:document-report" aria-hidden="false"></mat-icon>
<!--            <span class="pl-2 text-center ">Reportes</span>-->
            <span class="pl-2 text-center ">{{buttonTitle!=null ? buttonTitle : 'Reportes'}}</span>
        </button>

</div>
